module.exports = __webpack_public_path__ + "img/kpdf-1.265336f7.png";